import React from 'react';
import { Link, IndexLink } from 'react-router-dom';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import * as ImageUrl from "../../../constants/constant.js";
import * as constant from "../../../constants/constant.js";
import * as appointmentActions from '../../../actions/appointmentActions.js';
import * as disputeActions from '../../../actions/disputeActions.js';
import * as dashboardActions from "../../../actions/dashboardActions.js";
import ReactLoading from 'react-loading';
import { bindActionCreators } from 'redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Reaptcha from 'reaptcha';
import moment from 'moment';
import '../../../styles/css/disputeHelp.css'
import { Button, Form, FormGroup, Label, Input, Alert } from 'react-bootstrap';
import DisputeHeader from './disputeHeader.js';
import DisputeFooter from './disputeFooter.js';
// {constant.PRODUCTION_IMAGE_URL + 'patientImage/' + image}
const size = 10;
let btnSize = { fontSize: '13' };
class DisputeHelp extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            logoutButton: false,
            disputeList: [],
            isLoader: false,
            disputedAppointmentDetails: ''

        };
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.getAppointmentStatus = this.getAppointmentStatus.bind(this);
        this._logout = this._logout.bind(this);
    }
    handleOutsideClick = (e) => {
        // ignore clicks on the component itself
        if (this.node && this.node.contains(e.target)) {
            return;
        }

        this.handleClick();
    }
    handleClick = () => {
        if (!this.state.logoutButton) {
            // attach/remove event handler
            document.addEventListener('click', this.handleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.handleOutsideClick, false);
        }

        this.setState(prevState => ({
            logoutButton: !prevState.logoutButton,
        }));
    }
    _logout(event) {
        
        let userId = localStorage.getItem("userId");
        this.props.actions.logout({ 'userId': userId });

        event.preventDefault();
        localStorage.clear();
        this.props.history.push("/");
    }
    viewRecipt = () => {

        this.props.disputeactions.viewReceipt({
            appointmentId: this.props.match.params.appointmentId,
            userLocation: moment.tz.guess(),
            patientId: this.props.history.location.data.data.patientId._id
            //  data passed via link router
        })
    }


    componentWillMount() {
        
        let objectDocument = {
            appointmentId: this.props.match.params.appointmentId,
            isPastAppointment: true,
            isDisputed: true
        }

        if (objectDocument) {
            this.props.appointmentactions.getAppointmentDetails(objectDocument)
            this.props.disputeactions.getDisputeSubDisputeList();
        } else {
            // this.props.history.push('/')
        }
    }
    componentWillReceiveProps(nextProps) {
        
        if (nextProps.dispute && nextProps.dispute.listing) {
            this.setState({ disputeList: nextProps.dispute.listing.data, isLoader: false })
        }
        if(nextProps.appointment && nextProps.appointment.appointmentDetails) {
            this.setState({
                disputedAppointmentDetails : nextProps.appointment.appointmentDetails
            })
        }
    }

    searchDispute = (e) => {
        e.preventDefault()
        let searchTerm = this.state.searchTerm
        if (searchTerm) {
            // 
            // return;
            // this.props.history.match
            this.props.history.push({
                pathname: '/disputes/searchDisputelist',
                // search: `?query=${searchTerm}`,
                state: { searchTerm }
              })
            // this.props.disputeactions.searchDispute({searchTerm});
        }
    }
    onChange = (event) => {
        let inputName = event.target.name;
        let inputValue = event.target.value;
        this.setState({
            [inputName]: inputValue
        }, () => {
        });
    }

    getAppointmentStatus(status) {
        switch (status) {
            case '1': 
                return 'Not Completed'
            case '2': 
                return 'Completed'
            case '3': 
                return 'Doctor Not Shown'
            case '4': 
                return 'Patient Not Shown'
            case '5': 
                return 'Reserved'
            case '6': 
                return 'Cancelled By Doctor'
            case '7': 
                return 'Cancelled By Patient'
        }
    }

    render() {
        var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        if (user && user.gender == undefined) {
            user = { ...user, gender: 'Male' }
            // localStorage.setItem('user', JSON.stringify(user));
            // user = JSON.parse(localStorage.getItem("user"));
        }
        // var gender = localStorage.getItem('user')
        var defaultImagePath = (user && user.gender) == 'Male' ?
            constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        var imagePath = ''
        if (user && user.image == "noUserImage.jpg") {
            imagePath = user && user.gender == 'Male' ?
                constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        } else {
            imagePath =
                ImageUrl.PRODUCTION_IMAGE_URL +
                "uploads/" +
                localStorage.getItem("userId") +
                "/" +
                (user && user.image);
        }
        let rows = []
        if (this.state.disputeList && this.state.disputeList.length > 0) {
            this.state.disputeList.forEach(dispute => {
                let section =
                    <div key={dispute._id} className="col-md-4">
                        <div className="featureBlock d-flex">
                            {/* <div className="featureImg">  <img src={require('../../../images/stethoscope.svg')} alt=""  /></div> */}
                      

                        <div className="featureLinks" style={{"cursor": "pointer"}}>
                        {<Link to={`/dispute/${this.props.match.params.appointmentId}/${dispute.dispute[0]._id}`}><h3><a>{dispute._id}</a></h3></Link>}
                        {dispute.subDisputes.map((subDisputes, i) => {return <Link key={subDisputes._id} to={`/dispute/${this.props.match.params.appointmentId}/${dispute.dispute[0]._id}/${subDisputes._id}`}><p><a>{subDisputes.title}</a></p></Link>}
                        )}
                        </div>

                        </div>
                        
      
                    </div>
                rows.push(section)
            });
            // return rows
        } else {
            rows.push(<div className="col-md-6">
                Loading Dispute List
            </div>)

        }
        let disputedAppointment = this.state.disputedAppointmentDetails
        let specialistName = disputedAppointment.users ? disputedAppointment.users[0].userName : ''
        let patientName = disputedAppointment.users ? disputedAppointment.patient[0].userName : ''
        let appointmentDate = disputedAppointment ? disputedAppointment.checkappointmentDate : ''
        console.log("disputelist", this.state);
        let {
            city,
            clinicName,
            country,
            appointmentStatus,
            appointmentMode,
            appointmentTime,
        } = disputedAppointment
        return (
            <div className="wrapper">
                {this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> :
                    (<React.Fragment>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <DisputeHeader   inputRef={el => this.inputElement = el} _logout={this._logout} handleClick={this.handleClick} logoutButton={this.state.logoutButton} />
                                </div>
                            </div>
                        </div>
                        <div className="banner">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="banner-text">
                                            <h1>Having Trouble?</h1>
                                            <h1 className="sub-heading">We're here to help.</h1>
                                        </div>
                                        <form className="form-inline">
                                            <div className="form-group mt-4 d-flex">
                                                <input 
                                                type="text"
                                                className="form-control"
                                                placeholder="Describe your issue here"
                                                value={this.state.searchTerm}
                                                onChange={this.onChange}
                                                name="searchTerm"
                                                />
                                                <button
                                                className="btn btn-warning btn-lg"
                                                onClick={this.searchDispute}
                                                type="text"
                                                >Search</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="user-profile">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-2 offset-md-2">
                                        <div className="profile-image mb-5">
                                            <img src="https://picsum.photos/id/122/700/700" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="profile-details mb-5">
                                            <h4 className="name">Dr.{specialistName}</h4>
                                            <span className="info">patient name: {patientName}</span>
                                            <span className="info">appointment date: {moment(appointmentDate).format('DD-MM-YYYY')}</span>
                                            <span className="info">appointment time: {appointmentTime}</span>
                                            <span className="info">appointment mode: {appointmentMode == '1' ? 'Face 2 Face' : 'Online'}</span>
                                            <span className="info">status: { this.getAppointmentStatus(appointmentStatus) }</span>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="profile-address">
                                            <div className="addressLine d-flex">
                                                <i className="fa fa-home" aria-hidden="true"></i>
                                                <p style={{"marginLeft": "18px"}}>{ clinicName }</p>
                                            </div>
                                            <div className="addressLine d-flex">
                                                <i className="fa fa-map-marker" aria-hidden="true"></i>
                                                <p className="address" style={{"marginLeft": "22px"}}> {city + ',' + country/* Elmer Gardens, Isleworth, England,United Kingdom, TW76HA */}</p>
                                            </div>
                                            <div className="addressLine d-flex">
                                                <img src={require('../../../images/fees_icon.png')} alt="" />
                                                <p className="address">Consulation Fees</p>
                                            </div>
                                            <a onClick={this.viewRecipt} style={{"marginLeft": "13px", "cursor": "pointer", "font-size": "17px"}}>View Reciept</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="features">
                            <div className="container">
                            <div className="row">
                               <div className="col-md-8 offset-md-2">
                               <div className="row">
                                    {rows}
                                    {/* <div className="col-md-6">
                                <Link to="/dispute/appointmentId"><h3>General Issues</h3></Link>
                                <Link to="/dispute/appointmentId"><p>I did not book this Consulation</p></Link>
                                <Link to="/dispute/appointmentId"><p>Situation 2</p></Link>
                                <Link to="/dispute/appointmentId"><p>Situation 3</p></Link>
                                <Link to="/dispute/appointmentId"><p>Situation 4</p></Link>
                            </div>
                            <div className="col-md-6">
                                <Link to="/dispute/appointmentId"><h3>Payments and Refunds</h3></Link>
                                <Link to="/dispute/appointmentId"><p>I did not book this Consulation</p></Link>
                                <Link to="/dispute/appointmentId"><p>Situation 2</p></Link>
                                <Link to="/dispute/appointmentId"><p>Situation 3</p></Link>
                                <Link to="/dispute/appointmentId"><p>Situation 4</p></Link>
                            </div>
                            <div className="col-md-6">
                                <Link to="/dispute/appointmentId"><h3>My Specialist was Unprofessional</h3></Link>
                                <Link to="/dispute/appointmentId"><p>I did not book this Consulation</p></Link>
                                <Link to="/dispute/appointmentId"><p>Situation 2</p></Link>
                                <Link to="/dispute/appointmentId"><p>Situation 3</p></Link>
                                <Link to="/dispute/appointmentId"><p>Situation 4</p></Link>
                            </div>
                            <div className="col-md-6">
                                <Link to="/dispute/appointmentId"><h3>I had a diffrent issue</h3></Link>
                                <Link to="/dispute/appointmentId"><p>I did not book this Consulation</p></Link>
                                <Link to="/dispute/appointmentId"><p>Situation 2</p></Link>
                                <Link to="/dispute/appointmentId"><p>Situation 3</p></Link>
                                <Link to="/dispute/appointmentId"><p>Situation 4</p></Link>
                            </div> */}
                                </div>
                               </div>
                            </div>
                   
                            </div>
                        </div>
                        <DisputeFooter />
                    </React.Fragment>
                    )}

            </div>
        );
    }
}
//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
    return {
        dispute: state.dispute,
        appointment: state.appointment
        // specialistPatients: state.specialist.specialistPatients
    };
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        appointmentactions: bindActionCreators(appointmentActions, dispatch),
        disputeactions: bindActionCreators(disputeActions, dispatch),
        actions: bindActionCreators(dashboardActions, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(DisputeHelp);